var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNearIConSelectModal = function SvgNearIConSelectModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7E8A93",
    fillRule: "evenodd",
    d: "M6 0a6 6 0 0 0-6 6v4a6 6 0 0 0 6 6h4a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6H6Zm-.748 10.138V5.41l5.74 5.836c.744.757 2.185.306 2.185-.683v-5.71c0-.995-1.459-1.442-2.196-.671L9.215 6.847l.247.212 2.23-1.613v4.535l-5.74-5.836c-.745-.756-2.186-.306-2.186.683v5.839c0 .956 1.362 1.424 2.133.733l2.077-2.857-.248-.212-2.476 1.807Z",
    clipRule: "evenodd"
  })));
};
export default SvgNearIConSelectModal;